export default {
  "content": "<title>Git Branch</title><circle cx=\"160\" cy=\"96\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"160\" cy=\"416\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M160 368V144\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"352\" cy=\"160\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M352 208c0 128-192 48-192 160\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};